import React, { useEffect, useState } from "react";

// Shared across all our sites — see https://github.com/AlbertoMontalesi/affiliate-directory
// Pinned to a tag (not @latest) so an edit there can't break this site unannounced.
const AFFILIATE_DIRECTORY_URL =
  "https://cdn.jsdelivr.net/gh/AlbertoMontalesi/affiliate-directory@v1.4.0/affiliates.json";

// Used until the first fetch resolves, or if the CDN is unreachable.
const FALLBACK_AFFILIATES = [
  {
    id: "wise",
    name: "Wise",
    description:
      "Send money internationally with real exchange rates and save up to 6x on transfer fees.",
    ctaText: "Try Wise",
    url: "https://wise.com/invite/ihpc/albertom231",
    icon: "💸",
    backgroundColor: "#059669",
    textColor: "#ffffff",
  },
  {
    id: "educative",
    name: "Educative",
    description:
      "Interactive, text-based coding courses for web development, Python, and technical interview prep.",
    ctaText: "Explore Educative",
    url: "https://www.educative.io/?aff=BqmB",
    icon: "🎓",
    backgroundColor: "#1d4ed8",
    textColor: "#ffffff",
  },
];

const squareSidebar = {
  marginTop: "10px",
  width: "300px",
};

const squareContent = {
  marginTop: "40px",
  marginBottom: "50px",
};

const cardStyle = {
  width: "300px",
  padding: "20px",
  borderRadius: "8px",
  boxShadow: "1px 1px 5px 0px rgba(0,0,0,0.2)",
  cursor: "pointer",
  textAlign: "center",
};

const iconStyle = {
  fontSize: "32px",
  marginBottom: "10px",
};

const titleStyle = {
  fontWeight: "bold",
  fontSize: "18px",
  marginBottom: "8px",
};

const descriptionStyle = {
  fontSize: "13px",
  marginBottom: "12px",
  opacity: 0.9,
};

const buttonStyle = {
  border: "none",
  fontWeight: "bold",
  backgroundColor: "rgba(255,255,255,0.2)",
  padding: "8px 16px",
  borderRadius: "3px",
  fontSize: "14px",
};

function mapRemoteAffiliate(affiliate) {
  return {
    id: affiliate.id,
    name: affiliate.name,
    description: affiliate.description,
    ctaText: affiliate.ctaText ?? `Try ${affiliate.name}`,
    url: affiliate.url,
    icon: affiliate.icon,
    backgroundColor: affiliate.backgroundColor,
    textColor: affiliate.textColor,
  };
}

function InlineAffiliateAd(props) {
  const [affiliates, setAffiliates] = useState(FALLBACK_AFFILIATES);
  // content or sidebar;
  const position = props.position || "content";

  useEffect(() => {
    let isMounted = true;
    fetch(AFFILIATE_DIRECTORY_URL)
      .then((res) => res.json())
      .then((data) => {
        const fetched = (data.affiliates ?? [])
          .filter((a) => a.enabled)
          .map(mapRemoteAffiliate);
        if (isMounted && fetched.length > 0) {
          setAffiliates(fetched);
        }
      })
      .catch(() => {
        // keep using the fallback list
      });
    return () => {
      isMounted = false;
    };
  }, []);

  const affiliate = affiliates[Math.floor(Math.random() * affiliates.length)];

  if (!affiliate) return null;

  const handleClick = () => {
    window.open(affiliate.url, "_blank", "noopener,noreferrer");
  };

  return (
    <div
      className="row align-center"
      style={position === "sidebar" ? squareSidebar : squareContent}
    >
      <div
        style={{
          ...cardStyle,
          backgroundColor: affiliate.backgroundColor || "#0f172a",
          color: affiliate.textColor || "#ffffff",
        }}
        className={position === "sidebar" ? "col-12" : "col-10 col-md-6"}
        onClick={handleClick}
      >
        {affiliate.icon && <div style={iconStyle}>{affiliate.icon}</div>}
        <div style={titleStyle}>{affiliate.name}</div>
        <div style={descriptionStyle}>{affiliate.description}</div>
        <button style={{ ...buttonStyle, color: affiliate.textColor || "#ffffff" }}>
          {affiliate.ctaText}
        </button>
      </div>
    </div>
  );
}

export default InlineAffiliateAd;
